<template>
    <div class="karteikarten">
        <div id="shuffle" @click="shuffle">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="48"
                height="48"
                viewBox="0 0 172 172"
                style=" fill:#000000;"
            >
                <g
                    fill="none"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                >
                    <path d="M0,172v-172h172v172z" fill="none"></path>
                    <path
                        d="M21.5,172c-11.87412,0 -21.5,-9.62588 -21.5,-21.5v-129c0,-11.87412 9.62588,-21.5 21.5,-21.5h129c11.87412,0 21.5,9.62588 21.5,21.5v129c0,11.87412 -9.62588,21.5 -21.5,21.5z"
                        fill="#e05120"
                    ></path>
                    <g fill="#ffffff">
                        <path
                            d="M117.37292,25.83102c-0.63278,0.03616 -1.31979,0.23503 -1.88025,0.57854c-1.139,0.66893 -1.88025,1.88025 -1.88025,3.18196v10.12441h-4.6283c-3.10964,0 -6.85206,0.4339 -10.26904,2.31415c-3.41699,1.88025 -6.02041,4.66446 -8.3888,7.81026c-3.54354,4.7187 -7.90065,12.07697 -13.59563,21.69516c1.24747,-3.01924 0.81357,-6.49047 -1.15708,-9.11197c-4.7187,-7.84641 -7.66562,-12.78207 -11.71539,-16.77759c-4.04976,-3.99552 -10.32328,-5.93001 -15.04198,-5.93001h-13.8849c-0.28927,-0.01808 -0.57854,-0.01808 -0.86781,0c-5.11644,0.23503 -9.05773,4.57406 -8.8227,9.69051c0.23503,5.11644 4.57406,9.05773 9.69051,8.8227h13.8849c2.31415,0 0.74125,-0.54238 2.02488,0.72317c1.28363,1.26555 4.35711,5.36955 8.96733,13.0171c1.37403,2.83845 4.08592,4.79101 7.23172,5.17068c3.12772,0.37966 6.23736,-0.84973 8.24416,-3.29044c-1.51866,2.56726 -2.51302,4.33903 -4.33903,7.37636c-9.7809,16.21713 -15.24085,25.63645 -18.36857,29.79469c-1.5729,2.07912 -2.25991,2.56726 -2.31415,2.60342c-0.05424,0.03616 0.07232,0.14463 -1.44634,0.14463h-13.8849c-3.34467,-0.05424 -6.43623,1.69946 -8.11761,4.59214c-1.69946,2.87461 -1.69946,6.45431 0,9.32892c1.68137,2.89269 4.77294,4.64638 8.11761,4.59214h13.8849c3.10964,0 6.85206,-0.45198 10.26904,-2.31415c3.41699,-1.86217 6.02041,-4.66446 8.3888,-7.81026c4.73678,-6.2916 9.70858,-15.33125 19.38101,-31.38567c9.7809,-16.23521 15.09622,-25.63645 18.22394,-29.79469c1.55482,-2.07912 2.40455,-2.56726 2.45879,-2.60342c0.05424,-0.03616 -0.0904,-0.14463 1.44634,-0.14463h4.6283v10.12441c0,1.30171 0.74125,2.51302 1.88025,3.18196c0.6147,0.37966 1.31979,0.57854 2.02488,0.57854c0.59662,0 1.19324,-0.16271 1.73561,-0.4339l24.29858,-19.38101c1.17515,-1.10284 2.16952,-1.89833 2.16952,-3.32659c0,-1.41018 -0.84973,-2.15144 -2.16952,-3.32659l-24.29858,-19.38101c-0.59662,-0.30735 -1.24747,-0.47006 -1.88025,-0.4339zM117.37292,99.88384c-0.63278,0.03616 -1.31979,0.23503 -1.88025,0.57854c-1.139,0.66893 -1.88025,1.88025 -1.88025,3.18196v10.12441h-4.6283c-2.07912,0 -0.97628,0.36159 -1.73561,-0.28927c-0.75933,-0.65085 -3.07348,-3.43507 -6.50855,-8.96733c-1.77177,-2.98308 -5.08028,-4.70062 -8.53343,-4.48367c-3.25427,0.21695 -6.16504,2.11528 -7.64755,5.02605c-1.4825,2.91077 -1.31979,6.38199 0.41583,9.14812c3.68818,5.96617 6.34584,9.97977 10.26904,13.30637c3.92321,3.32659 9.50972,4.77294 13.74027,4.77294h4.6283v10.12441c0,1.30171 0.74125,2.51302 1.88025,3.18196c0.6147,0.37966 1.31979,0.57854 2.02488,0.57854c0.59662,0 1.19324,-0.16271 1.73561,-0.4339l24.29858,-19.38101c1.17515,-1.10284 2.16952,-1.89833 2.16952,-3.32659c0,-1.41018 -0.84973,-2.15144 -2.16952,-3.32659l-24.29858,-19.38101c-0.59662,-0.30735 -1.24747,-0.47006 -1.88025,-0.4339z"
                        ></path>
                    </g>
                    <path
                        d="M21.5,172c-11.87412,0 -21.5,-9.62588 -21.5,-21.5v-129c0,-11.87412 9.62588,-21.5 21.5,-21.5h129c11.87412,0 21.5,9.62588 21.5,21.5v129c0,11.87412 -9.62588,21.5 -21.5,21.5z"
                        fill="none"
                    ></path>
                    <path
                        d="M24.94,168.56c-11.87412,0 -21.5,-9.62588 -21.5,-21.5v-122.12c0,-11.87412 9.62588,-21.5 21.5,-21.5h122.12c11.87412,0 21.5,9.62588 21.5,21.5v122.12c0,11.87412 -9.62588,21.5 -21.5,21.5z"
                        fill="none"
                    ></path>
                </g>
            </svg>
        </div>
        <transition-group name="cards" tag="div" id="cardGrid">
            <karteikarte
                v-for="card in cards"
                :title="card.title"
                :key="card.title"
                :is-active="card.isActive"
            >
                <component :is="card.component"></component>
            </karteikarte>
        </transition-group>
    </div>
</template>

<script>
import Karteikarte from '../../components/karteikarte';
import shuffle from 'lodash.shuffle';

import MehrfachbindungNachweis from './karteikarten/reaktionen-nachweise/mehrfachbindung-nachweis';
import EsterSynthese from './karteikarten/reaktionen-nachweise/ester-synthese-mechanismus';
import Oxonium from './karteikarten/reaktionen-nachweise/oxonium-ionen';
import HalogenKohlenWasserstoffe from './karteikarten/reaktionen-nachweise/halogen-kohlenwasserstoffe';
import RadikalischeSubstitution from './karteikarten/reaktionen-nachweise/radikalische-substitution-mechanismus';
import ElektrophileAddition from './karteikarten/reaktionen-nachweise/elektrophile-addition-mechanismus';
import ElektrophileSubstitution from './karteikarten/reaktionen-nachweise/elektrophile-substitution-mechanismus';
import Polymerisation from './karteikarten/reaktionen-nachweise/polymerisation';
import ChloridIonen from './karteikarten/reaktionen-nachweise/chlorid-ionen';
import IodidIonen from './karteikarten/reaktionen-nachweise/iodid-ionen';
import HydroxidIonen from './karteikarten/reaktionen-nachweise/hydroxid-ionen';
import Wasser from './karteikarten/reaktionen-nachweise/wasser';
import Polyester from './karteikarten/reaktionen-nachweise/polyester';
import Polyamid from './karteikarten/reaktionen-nachweise/polyamid';
import Alkali from './karteikarten/reaktionen-nachweise/alkali';
import Wasserstoff from './karteikarten/reaktionen-nachweise/wasserstoff';
import AldehydNachweis from './karteikarten/reaktionen-nachweise/aldehyd-nachweis';
import AldehydFehling from './karteikarten/reaktionen-nachweise/aldehyd-fehling';
import CO2 from './karteikarten/reaktionen-nachweise/co2';
import Staerke from './karteikarten/reaktionen-nachweise/staerke';
import DoppelBaeyer from './karteikarten/reaktionen-nachweise/nachweis-doppel-baeyer';

const random = () => !Math.round(Math.random());

export default {
    components: { Karteikarte },
    data() {
        return {
            cards: shuffle([
                {
                    title: 'Mehrfachbindung Nachweis',
                    component: MehrfachbindungNachweis,
                    isActive: random(),
                },
                {
                    title: 'Ester-Synthese Mechanismus',
                    component: EsterSynthese,
                    isActive: random(),
                },
                {
                    title: 'Oxonium-Ionen (Hydronium)',
                    component: Oxonium,
                    isActive: random(),
                },
                {
                    title: 'Halogen-Kohlenwasserstoffe',
                    component: HalogenKohlenWasserstoffe,
                    isActive: random(),
                },
                {
                    title: 'Radikalische Substitution Mechanismus',
                    component: RadikalischeSubstitution,
                    isActive: random(),
                },
                {
                    title: 'Polymerisation',
                    component: Polymerisation,
                    isActive: random(),
                },
                {
                    title: 'Chlorid-Ionen',
                    component: ChloridIonen,
                    isActive: random(),
                },
                {
                    title: 'Iodid-Ionen',
                    component: IodidIonen,
                    isActive: random(),
                },
                {
                    title: 'Hydroxid-Ionen',
                    component: HydroxidIonen,
                    isActive: random(),
                },
                {
                    title: 'Wasser',
                    component: Wasser,
                    isActive: random(),
                },
                {
                    title: 'Polykondensation / Polyester',
                    component: Polyester,
                    isActive: random(),
                },
                {
                    title: 'Polykondensation / Polyamid',
                    component: Polyamid,
                    isActive: random(),
                },
                {
                    title: 'Elektrophile Addition Mechanismus',
                    component: ElektrophileAddition,
                    isActive: random(),
                },
                {
                    title: 'Elektrophile Substitution Mechanismus',
                    component: ElektrophileSubstitution,
                    isActive: random(),
                },
                {
                    title: 'Alkali- und Erdalkalimetalle',
                    component: Alkali,
                    isActive: random(),
                },
                {
                    title: 'Wasserstoff',
                    component: Wasserstoff,
                    isActive: random(),
                },
                {
                    title: 'Aldehyd Nachweis',
                    component: AldehydNachweis,
                    isActive: random(),
                },
                {
                    title: 'Aldehyd Nachweis',
                    component: AldehydFehling,
                    isActive: random(),
                },
                {
                    title: 'Kohlenstoffdioxid',
                    component: CO2,
                    isActive: random(),
                },
                {
                    title: 'Stärke',
                    component: Staerke,
                    isActive: random(),
                },
                {
                    title: 'Nachweis von Doppelbindung (Alternative)',
                    component: DoppelBaeyer,
                    isActive: random(),
                },
            ]),
        };
    },
    methods: {
        shuffle() {
            this.cards.forEach(card => (card.isActive = random()));
            this.cards = shuffle(this.cards);
        },
    },
};
</script>

<style scoped lang="sass">
#cardGrid
    padding: 71px 20px 20px
    display: -ms-grid
    display: grid
    grid-gap: 16px
    /*-ms-grid-columns: (minmax(600px, 1fr))[auto-fit]*/
    grid-template-columns: repeat(auto-fit, minmax(600px, 1fr))
    text-align: center

#shuffle
    position: fixed
    top: 1%
    right: 1%
    cursor: pointer

.cards-move
    transition: transform 1s ease-in-out
</style>
